import { render, staticRenderFns } from "./StoreArticlesManager.vue?vue&type=template&id=30860928&"
import script from "./StoreArticlesManager.vue?vue&type=script&lang=js&"
export * from "./StoreArticlesManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports